import { Checkbox, FormControlLabel, Typography } from '@mui/material';

export interface LabelCheckboxProps {
  checked: boolean;
  onCheck: (checked: boolean) => void;
  title: string;
  stretch?: boolean;
}

export const LabelCheckbox = ({
  checked,
  onCheck,
  title,
  stretch = false,
}: LabelCheckboxProps) => {
  return (
    <FormControlLabel
      sx={[
        styles.checkboxContainer,
        stretch && { justifyContent: 'space-between' },
      ]}
      value={checked}
      label={<Typography variant="body3SemiBold">{title}</Typography>}
      labelPlacement={'end'}
      control={
        <Checkbox
          sx={styles.checkbox}
          checked={checked}
          onChange={() => onCheck(!checked)}
        />
      }
    />
  );
};

const styles = {
  checkboxContainer: {
    display: 'flex',

    margin: 0,
    userSelect: 'none',
  },
  selected: {
    color: 'primary.main',
  },
  unselected: {
    color: 'grey150',
  },
  checkbox: {
    padding: 0.5,
    '&.MuiCheckbox-root': {
      color: 'grey150',
    },
    '&.Mui-checked': {
      color: 'primary.main',
    },
  },
};
